export enum AvenAdvisorLiabilityQuizV2QuizType {
    ONBOARDING_MORTGAGE_TEXT_BOX_ONLY = 'onboarding_mortgage_text_box_only',
    ONBOARDING_HELOC_TEXT_BOX_ONLY = 'onboarding_heloc_text_box_only',
    ONBOARDING_REVOLVING_CREDIT_CARD_BALANCE_TEXT_BOX_ONLY = 'onboarding_revolving_credit_card_balance_text_box_only',
}

export type AvenAdvisorOnboardingMortgageQuizJan2026Data = {
    quizType: AvenAdvisorLiabilityQuizV2QuizType.ONBOARDING_MORTGAGE_TEXT_BOX_ONLY
    interestRate: number | null
}

export type AvenAdvisorOnboardingHELOCQuizJan2026Data = {
    quizType: AvenAdvisorLiabilityQuizV2QuizType.ONBOARDING_HELOC_TEXT_BOX_ONLY
    interestRate: number | null
}

export type AvenAdvisorOnboardingRevolvingCreditCardBalanceQuizJan2026Data = {
    quizType: AvenAdvisorLiabilityQuizV2QuizType.ONBOARDING_REVOLVING_CREDIT_CARD_BALANCE_TEXT_BOX_ONLY
    revolvingBalanceCents: number | null
}

export type AvenAdvisorOnboardingLiabilityQuizJan2026Data =
    | AvenAdvisorOnboardingMortgageQuizJan2026Data
    | AvenAdvisorOnboardingHELOCQuizJan2026Data
    | AvenAdvisorOnboardingRevolvingCreditCardBalanceQuizJan2026Data
